import React, { useState } from "react";
import { Row, Col  } from 'reactstrap';
import { Divider, withStyles } from '@material-ui/core';
import DataServiceSQL from "../../DataService/DataServiceSQL";
import cookie from 'react-cookies';
import * as Constants from '../../Pages/Constants';
import InvalidObject from '../Common/InvalidObject.js';
import {FormattedMessage} from 'react-intl';

/** Used by AddChild.js and DeleteChild.js
 *  Each item represents a child to add/delete in a group
 */
const ItemListReceivedRequest = (props) => {
    const [isAnswered, setIsAnswered] = useState("");
    const [answerDisplay, setAnswerDisplay] = useState("");
    const [selectedProfile, setSelectedProfile] = useState("--");
    const [displayWrongSelection, setDisplayWrongSelection] = useState(false);

    //Accept a structure-sharing invite
    const acceptStructureInvite = async (request_id) => {
        try {
            await DataServiceSQL.answerStructureRequest(request_id, true);
            await props.reloadUserAndProfiles();
            setAnswerDisplay("Request accepted");
            setIsAnswered(true);
        } catch (e) {
            // 409 => another admin of the structure already accepted it.
            if (e && e.response && e.response.status === 409) {
                const by = e.response.data && e.response.data.accepted_by;
                setAnswerDisplay(by ? ("Déjà accepté — " + by) : "Déjà accepté");
                setIsAnswered(true);
                if (typeof props.reloadUserAndProfiles === "function") await props.reloadUserAndProfiles();
                return;
            }
            setAnswerDisplay("Error - Can't validate request");
            setIsAnswered(true);
        }
    };

    //Refuse a structure-sharing invite
    const refuseStructureInvite = async (request_id) => {
        try {
            await DataServiceSQL.answerStructureRequest(request_id, false);
            setAnswerDisplay("Request refused");
            setIsAnswered(true);
        } catch (e) {
            setAnswerDisplay("Error");
            setIsAnswered(true);
        }
    };

    //Accept delegate-medical invite
    const acceptDelegateInvite = async (request_id) => {
        try {
            await DataServiceSQL.answerDelegateInviteSQL(request_id, true);
            if (typeof props.reloadUserAndProfiles === "function") {
                await props.reloadUserAndProfiles();
            }
            setAnswerDisplay("Invitation acceptée");
            setIsAnswered(true);
        } catch (e) {
            setAnswerDisplay("Erreur - Impossible d'accepter");
            setIsAnswered(true);
        }
    };

    //Refuse delegate-medical invite
    const refuseDelegateInvite = async (request_id) => {
        try {
            await DataServiceSQL.answerDelegateInviteSQL(request_id, false);
            setAnswerDisplay("Invitation refusée");
            setIsAnswered(true);
        } catch (e) {
            setAnswerDisplay("Erreur");
            setIsAnswered(true);
        }
    };

    //Accept profile creation request
    const accept = async (request_id) => {

        //console.log("selectedProfile: " + selectedProfile)

        // When the user owns a single profile, it's the implicit target (no dropdown
        // is shown), so use it directly instead of the unselected "--" placeholder.
        const profileId = (props.profilesInformation && props.profilesInformation.length === 1)
            ? props.profilesInformation[0].Patient_Data.id_patient
            : selectedProfile;

        if(profileId !== "--"){
          let data = {
            resourceType : "Linkage",
            active : true,
            author : props.request.recipient_mail_address,
            item : [
              {
                type : "source",
                resource : {
                  type : "Patient",
                  reference : profileId
                }
              },
              {
                type : "source",
                resource : {
                  type : "Practitioner",
                  reference : props.request.requester_mail_address
                }
              }
            ]
          }

          await DataServiceSQL.updateLinkage_fhir(data)
            .then(async (response) => {
              await props.reloadUserAndProfiles()
              setAnswerDisplay("Request accepted")
              setIsAnswered(true);
            })
            .catch((e) => {
              setAnswerDisplay("Error - Can't validate request")
              setIsAnswered(true);
            });
        }
        else{
          setDisplayWrongSelection(true);
        }

    }

    //Refuse profile creation request
    const refuse = (request_id) => {
        DataServiceSQL.deleteLinkage_fhir(props.request.recipient_mail_address, props.request.requester_mail_address)
        setAnswerDisplay("Request refused")
        setIsAnswered(true);
    }

    //Function to handle select value changes
    const onChangeSelectedProfile = (event) => {
        event.preventDefault();
        setSelectedProfile(event.target.value);
    }

    //Function to manage wrong selection popup display
    const manageWrongSelectionPopupDisplay = () => {
      setDisplayWrongSelection(!displayWrongSelection);
    }

    const { request } = props;

    // Delegate-medical invite: direct email invite for patient delegation
    // (FK_patient set to any truthy value, no recipient_structure_id)
    const isDelegateMedicalInvite = !!(request.FK_patient) && !request.recipient_structure_id;

    const patientLabel = (() => {
      const fn = request.patient_firstname || '';
      const ln = request.patient_lastname || '';
      return (fn + ' ' + ln).trim() || null;
    })();

    return (
      <div>
        <Divider style={{ width: "100%", backgroundColor:"#000000", marginTop: "5px", marginBottom: "5px" }} />
          <Row>
            <Col style={{ maxWidth: "50%", textAlign: "center", paddingTop: '6px', fontWeight: "bold"}}>
                {request.requester_struct_name}
                {patientLabel && (isDelegateMedicalInvite || request.recipient_structure_id) && (
                  <div style={{ fontWeight: "normal", fontSize: "0.9em", color: "#555" }}>
                    {patientLabel}
                  </div>
                )}
            </Col>
            <Col style={{width: "50%", textAlign: "center", fontWeight: "bold"}}>
              {isAnswered ?
                <div>
                  <h4 style={{marginTop: "5px"}}>{answerDisplay}</h4>
                </div>
                :
                isDelegateMedicalInvite ? (
                  // Direct delegate-medical invite: accept/refuse without profile selector
                  <div>
                    {request.delegate_name && (
                      <span style={{fontSize: "0.9em", display: "block", marginBottom: "4px"}}>
                        <FormattedMessage id="invitation.delegateFor" defaultMessage="Délégué alertes médicales" />
                        {" — "}{request.delegate_name}
                      </span>
                    )}
                    <b>&emsp;</b>
                    <button onClick={() => refuseDelegateInvite(request.request_id)} className="btn btn-danger">
                      <FormattedMessage id="button.refuse" defaultMessage="Refuse"/>
                    </button>
                    <button onClick={() => acceptDelegateInvite(request.request_id)} className="btn btn-success">
                      <FormattedMessage id="button.accept" defaultMessage="Accept"/>
                    </button>
                  </div>
                ) :
                request.recipient_structure_id ? (
                  // Structure-sharing invite: patient is already determined, no selector needed
                  <div>
                    {request.delegate_name && (
                      <span style={{fontSize: "0.9em", display: "block", marginBottom: "4px"}}>
                        {request.delegate_name}
                      </span>
                    )}
                    {request.status === 'accepted' ? (
                      // Already validated by another admin of the structure: show by whom, no buttons.
                      <span style={{fontSize: "0.9em", color: "#2e7d32", fontWeight: "bold"}}>
                        ✓ <FormattedMessage id="invitation.alreadyAccepted" defaultMessage="Déjà accepté" />
                        {request.accepted_by_email ? " — " + request.accepted_by_email : ""}
                      </span>
                    ) : request.status === 'refused' ? (
                      // Already declined by another admin of the structure: show by whom, no buttons.
                      <span style={{fontSize: "0.9em", color: "#c62828", fontWeight: "bold"}}>
                        ✕ <FormattedMessage id="invitation.alreadyRefused" defaultMessage="Refusé" />
                        {request.accepted_by_email ? " — " + request.accepted_by_email : ""}
                      </span>
                    ) : (
                      <>
                        <b>&emsp;</b>
                        <button onClick={() => refuseStructureInvite(request.request_id)} className="btn btn-danger">
                          <FormattedMessage id="button.refuse" defaultMessage="Refuse"/>
                        </button>
                        <button onClick={() => acceptStructureInvite(request.request_id)} className="btn btn-success">
                          <FormattedMessage id="button.accept" defaultMessage="Accept"/>
                        </button>
                      </>
                    )}
                  </div>
                ) : (
                <div>
                  {props.profilesInformation.length === 1 ? (
                    // A single profile: nothing to choose, show the patient directly.
                    <span style={{ fontWeight: "bold" }}>
                      {props.profilesInformation[0].Patient_Data.firstname + " " + props.profilesInformation[0].Patient_Data.lastname}
                    </span>
                  ) : (
                    <select defaultValue={selectedProfile} onChange={onChangeSelectedProfile} id="sel" name="sel">
                      <option value={"--"} key={"--"}>--</option>
                      {
                          props.profilesInformation.map((profile,index)=> {
                              return (<option value={profile.Patient_Data.id_patient} key={index}>{profile.Patient_Data.firstname + " " + profile.Patient_Data.lastname}</option>);
                          })
                      }
                    </select>
                  )}
                  <b>&emsp;</b>
                  <button onClick={() => {refuse(request.request_id)}} className="btn btn-danger">
                    <FormattedMessage id="button.refuse" defaultMessage="Refuse"/>
                  </button>
                  <button onClick={()=>{accept(request.request_id)}} className="btn btn-success">
                    <FormattedMessage id="button.accept" defaultMessage="Accept"/>
                  </button>
                </div>
                )
              }
            </Col>
          </Row>
          {displayWrongSelection ? <InvalidObject message={"Please select a profile"} cancelPopup={manageWrongSelectionPopupDisplay}/> : null}
      </div>
    );
};
export default withStyles(Constants.styles)(ItemListReceivedRequest);